import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LAYOUT_COLUMN__left } from '@/pages/_base/layout_base/LAYOUT_COLUMN__left';
import { LAYOUT_COLUMN__right } from '@/pages/_base/layout_base/LAYOUT_COLUMN__right';
import { FOOTER__master } from '@/pages/_base/layout_footer/FOOTER__master';
import { HEADER__master } from '@/pages/_base/layout_header/HEADER__master';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { G_LAYOUT__IMAGE_EDIT__mask } from '@/pages/page_generation/layouts/assets_images/tab_mask/G_LAYOUT__IMAGE_EDIT__mask';
import { G_LAYOUT__image_view } from '@/pages/page_generation/layouts/assets_images/tab_view/G_LAYOUT__image_view';
import { G_HEADER__column_center } from '../../view_header/G_HEADER__column_center';
import { G_HEADER__generation_actions } from '../../view_header/G_HEADER__generation_actions';
import { G_BAR__layout_tabs } from '../_base/G_BAR__layout_tabs';
import { G_DROPDOWN__generation_tool } from '../_base/graph_template/G_DROPDOWN__generation_tool';
import { G_DROPDOWN__generation_output_type } from '../outputs/sidebar/G_DROPDOWN__generation_output_type';
import { G_SIDEBAR__fields_images } from './_base/G_SIDEBAR__fields_images';
import { WATCHER__image_edit_select_field } from './_watchers/WATCHER__image_edit_select_field';
import { G_BAR__layout_image_edit_tabs } from './G_BAR__layout_image_edit_tabs';
import { G_LAYOUT__image_edit_crop_box } from './tab_crop_box/G_LAYOUT__image_edit_crop_box';
import { G_SIDEBAR__IMAGE_EDIT__crop_box } from './tab_crop_box/G_SIDEBAR__IMAGE_EDIT__crop_box';
import { G_LAYOUT__IMAGE_EDIT__line_draw } from './tab_line_draw/G_LAYOUT__IMAGE_EDIT__line_draw';
import { G_SIDEBAR__IMAGE_EDIT__line_draw } from './tab_line_draw/G_SIDEBAR__IMAGE_EDIT__line_draw';
import { G_SIDEBAR__IMAGE_EDIT__mask } from './tab_mask/G_SIDEBAR__IMAGE_EDIT__mask';
import { G_LAYOUT__image_replace } from './tab_replace/G_LAYOUT__image_replace';
import { G_SIDEBAR__IMAGE_EDIT__image_replace } from './tab_replace/G_SIDEBAR__IMAGE_EDIT__image_replace';
import { G_LAYOUT__image_edit_segments } from './tab_segments/G_LAYOUT__image_edit_segments';
import { G_LAYOUT__image_edit_segments_to_mask } from './tab_segments_to_mask/G_LAYOUT__image_edit_segments_to_mask';
import { G_SIDEBAR__IMAGE_EDIT__view } from './tab_view/G_SIDEBAR__IMAGE_EDIT__view';

export function G_LAYOUT__image_edit_master() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();
  const { g_image_edit__field, g_image_edit__tab } = use_slice_ui(['g_image_edit__field', 'g_image_edit__tab']);

  /*
   * EVENTS
   */

  /*
   * RENDERS
   */
  function render_no_image_selected() {
    if (!g_image_edit__field.is_stub()) return null;

    return <div className="size-full bg-component flex flex-center text-xl text-component-item-foreground">No field for edit selected</div>;
  }

  function render_tab_content() {
    if (g_image_edit__field.is_stub()) return null;

    let ENUM = ENUM__page_generation_layout_images_edit_tab;

    const out_map = new Map([
      [ENUM.VIEW, <G_LAYOUT__image_view />],
      [ENUM.CROP, <G_LAYOUT__image_edit_crop_box />],
      [ENUM.MASK, <G_LAYOUT__IMAGE_EDIT__mask />],
      [ENUM.LINE__DRAW, <G_LAYOUT__IMAGE_EDIT__line_draw />],
      //
      [ENUM.SEGMENTS, <G_LAYOUT__image_edit_segments />],
      [ENUM.SEGMENTS_TO_MASK, <G_LAYOUT__image_edit_segments_to_mask />],
      //
      [ENUM.SELECT, <G_LAYOUT__image_replace />],
    ]);

    return out_map.get_or_assert(g_image_edit__tab);
  }

  function render_sidebar_right() {
    return (
      <LAYOUT_COLUMN__right>
        <G_SIDEBAR__fields_images />
      </LAYOUT_COLUMN__right>
    );
  }

  function render_sidebar_left() {
    let ENUM = ENUM__page_generation_layout_images_edit_tab;

    const out_map = new Map([
      [ENUM.VIEW, <G_SIDEBAR__IMAGE_EDIT__view />],
      [ENUM.CROP, <G_SIDEBAR__IMAGE_EDIT__crop_box />],
      [ENUM.MASK, <G_SIDEBAR__IMAGE_EDIT__mask />],
      [ENUM.LINE__DRAW, <G_SIDEBAR__IMAGE_EDIT__line_draw />],
      //
      [ENUM.SEGMENTS, <></>],
      [ENUM.SEGMENTS_TO_MASK, <></>],
      [ENUM.SELECT, <G_SIDEBAR__IMAGE_EDIT__image_replace />],
    ]);

    let out = out_map.get_or_assert(g_image_edit__tab);

    return (
      <LAYOUT_COLUMN__left>
        <div className="flex flex-col size-full">
          <G_DROPDOWN__generation_output_type is_readonly />
          <PLACEHOLDER_bar_line className="w-full h-6 border-b border-component-border" />
          <G_DROPDOWN__generation_tool is_readonly />

          {out}
        </div>
      </LAYOUT_COLUMN__left>
    );
  }

  /*
   * HTML
   */

  return (
    <div className="flex flex-col w-full h-screen">
      <WATCHER__image_edit_select_field />

      <HEADER__master column_center={<G_HEADER__column_center />} column_right={<G_HEADER__generation_actions />} />

      <div className="flex flex-row w-full flex-1 min-h-0">
        {render_sidebar_left()}

        <div className="layout_image_edit_column_center flex flex-col items-start justify-start flex-1 overflow-hidden">
          <G_BAR__layout_tabs />
          <G_BAR__layout_image_edit_tabs />

          <div className="layout_image_edit_content w-full min-h-0 flex-1">
            {render_tab_content()}
            {render_no_image_selected()}
          </div>
        </div>

        {render_sidebar_right()}
      </div>

      <FOOTER__master />
    </div>
  );
}
